import { render, staticRenderFns } from "./statistical-analysis-info-paginator.vue?vue&type=template&id=ef4d702a&scoped=true&"
import script from "./statistical-analysis-info-paginator.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-info-paginator.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-info-paginator.scss?vue&type=style&index=0&id=ef4d702a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4d702a",
  null
  
)

export default component.exports